/**
 * UnsavedChangesDialog Component
 * 
 * A reusable dialog that warns users about unsaved changes before closing.
 * 
 * Usage:
 * <UnsavedChangesDialog
 *   open={showConfirmDialog}
 *   onConfirm={confirmDiscard}
 *   onCancel={cancelClose}
 * />
 */
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './alert-dialog';
import { AlertTriangle } from 'lucide-react';

export function UnsavedChangesDialog({
  open,
  onConfirm,
  onCancel,
  title = 'Alterações não salvas',
  description = 'Você tem alterações que não foram salvas. Se sair agora, essas alterações serão perdidas.',
  confirmText = 'Sair sem salvar',
  cancelText = 'Continuar editando',
}) {
  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel?.()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-500" />
            {title}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            {cancelText}
          </AlertDialogCancel>
          <AlertDialogAction 
            onClick={onConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default UnsavedChangesDialog;
